module.exports = __webpack_public_path__ + "icons/original/large/large-f3.0070d3861e60350f291165d89028d7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-f3.png
// module id = gVWB
// module chunks = app